<template>
  <div id="app">
    <div id="lottie"></div>
    <router-view />
  </div>
</template>
<script>
import autofit from 'autofit.js'
export default {
  mounted() {
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: "#app",
      resize: true
    })
    this.animation()
  },
  methods: {
    animation() {
      var animationData = { "v": "5.6.5", "fr": 25, "ip": 0, "op": 250, "w": 1269, "h": 1269, "nm": "Frame 1571", "ddd": 0, "assets": [{ "id": "image_0", "w": 623, "h": 623, "u": "images/", "p": "img_0.png", "e": 0 }, { "id": "image_1", "w": 665, "h": 665, "u": "images/", "p": "img_1.png", "e": 0 }, { "id": "image_2", "w": 1269, "h": 1269, "u": "images/", "p": "img_2.png", "e": 0 }, { "id": "image_3", "w": 1164, "h": 1164, "u": "images/", "p": "img_3.png", "e": 0 }, { "id": "image_4", "w": 758, "h": 758, "u": "images/", "p": "img_4.png", "e": 0 }, { "id": "image_5", "w": 744, "h": 743, "u": "images/", "p": "img_5.png", "e": 0 }], "layers": [{ "ddd": 0, "ind": 1, "ty": 2, "nm": "Frame 1571.png", "cl": "png", "refId": "image_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 250, "s": [720] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [311.5, 311.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 2, "ty": 2, "nm": "Union-4.png", "cl": "png", "refId": "image_1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 250, "s": [720] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [332.5, 332.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 2, "nm": "Union.png", "cl": "png", "refId": "image_2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 250, "s": [360] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [634.5, 634.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 2, "nm": "Union-1.png", "cl": "png", "refId": "image_3", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 249, "s": [720] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [582, 582, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 2, "nm": "Union-2.png", "cl": "png", "refId": "image_4", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 249, "s": [360] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [379, 379, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 6, "ty": 2, "nm": "Union-3.png", "cl": "png", "refId": "image_5", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] }, { "t": 249, "s": [360] }], "ix": 10 }, "p": { "a": 0, "k": [634.5, 634.5, 0], "ix": 2 }, "a": { "a": 0, "k": [372, 371.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 252, "st": 0, "bm": 0 }], "markers": [] };
      var params = {
        container: document.getElementById('lottie'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      };


      let anim = lottie.loadAnimation(params);
    }
  }
}
</script>
<style lang="less">
#lottie {
  position: absolute;
  width: 110%;
  height: 110%;
  top: -11%;
  left: -5%;
  z-index: -9999;
  // opacity: 0.65;
  transform: translate3d(0, 0, 0);
}
::selection {
  background-color: #0e7ee6;
  color: #fff;
}
* {
  box-sizing: border-box;
}
#app {
  position: relative;
  padding: 0 48px;
  background: url("./assets/bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

.el-input {
  .el-input__inner {
    background: #0b3444;
    border: 1px solid #0f81eb !important;
    color: #fff;
  }
}

.el-button {
  background: #0f81eb !important;
  border: 1px solid #0f81eb !important;
  color: #fff !important;
  font-size: 14px !important;
}

.popper__arrow::after {
  border-bottom-color: #5696e7 !important;
}
.el-tooltip__popper {
  background: #5696e7 !important;
}

.el-table {
  &::before {
    height: 0px !important;
  }
  thead tr {
    background: transparent;
    border-bottom: 1px solid #0f81eb;
    background: linear-gradient(
      0deg,
      #0f81eb -67.11%,
      rgba(15, 129, 235, 0) 196.05%
    );
  }
  .el-table__header-wrapper .el-table__header {
    th.el-table__cell {
      height: 38px;
      border-bottom: 1px solid #0f81eb;
      background: transparent;
      color: #fff;
      text-align: center;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
    }
  }
  .el-table__body-wrapper {
    tr {
      // border-bottom: 1px solid #0f81eb;
      background: rgba(108, 128, 151, 0.1);
    }
    .el-table__cell {
      border-bottom: 1px solid #0f81eb !important;
    }
    tr:hover .el-table__cell {
      background: rgba(54, 90, 131, 0.5) !important;
      cursor: pointer;
    }
  }
  .el-table__row {
    height: 38px;
    color: #fff;
    text-align: center;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-style: normal;
    font-weight: 200;
    line-height: 22px; /* 157.143% */
  }
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}
</style>
